// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "style/" + chunkId + "." + {"28":"7e8f8ec29b4c7b28fa01","154":"79b18d10b96514d90cae","961":"cf11786ba479026793e6"}[chunkId] + ".css";
};